__turbopack_context__.v({
  "bold": "unity-intructions-modal-module__dRp8-q__bold",
  "boldMainTitle": "unity-intructions-modal-module__dRp8-q__boldMainTitle",
  "boldTitle": "unity-intructions-modal-module__dRp8-q__boldTitle",
  "li": "unity-intructions-modal-module__dRp8-q__li",
  "link": "unity-intructions-modal-module__dRp8-q__link",
});
